// adminThunks.ts
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchAdminData = createAsyncThunk<
  any, // Replace `any` with your expected return type
  string, // The argument will be the idToken (JWT)
  { rejectValue: string }
>("admin/fetchAdminData", async (idToken, { rejectWithValue }) => {
  try {
    const response = await fetch(
      "https://m01op8z79h.execute-api.us-east-2.amazonaws.com/default/avro-admin",
      {
        method: "GET", // Change to POST if needed
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      return rejectWithValue(errorText || "Failed to fetch admin data.");
    }

    const data = await response.json();
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message || "An unknown error occurred.");
  }
});
